import {Injectable} from "@angular/core";
import {Storage} from '@capacitor/storage';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {
  }

  public async set(key: string, value?: any): Promise<void> {
    await Storage.set({
      key: key,
      value: JSON.stringify(value),
    });
  }

  public async get(key: string): Promise<any> {
    let value: any;
    value = await Storage.get({key: key});
    try {
      value = value.value;
    } catch (e) {
      return;
    }
    return JSON.parse(value);
  }
}
